import { faCircle, faFolderOpen } from '@fortawesome/pro-solid-svg-icons';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { startReadingNotification } from '../../actions/notification';
import { changePage } from '../../actions/project';
import { FolderIcon, IconContainer, FolderContainer, MenuItem, NotifContainer, NotifDate, NotifNameRecap, NotifProjectName, NotifText, RedPointIcon } from './styled';
const ProjectName = _ref => {
  let {
    notif,
    isPage
  } = _ref;
  return /*#__PURE__*/React.createElement(NotifProjectName, {
    disabled: notif.isRead,
    isPage: isPage
  }, notif.project.name || notif.project.projectname || notif.project.dealname);
};
const NotifTextFormatted = _ref2 => {
  let {
    notif,
    isPage
  } = _ref2;
  const splittedText = notif.meta.textMultiProject ? notif.meta.textMultiProject.split('nom_du_projet') : [];
  return /*#__PURE__*/React.createElement(NotifText, {
    isPage: isPage
  }, splittedText.length > 0 ? /*#__PURE__*/React.createElement(Fragment, null, splittedText[0], /*#__PURE__*/React.createElement(ProjectName, {
    notif: notif,
    isPage: isPage
  }), splittedText[1]) : /*#__PURE__*/React.createElement(Fragment, null, `${notif.meta.text}`));
};
const MultiNotificationsList = _ref3 => {
  let {
    notifications,
    isPage
  } = _ref3;
  const dispatch = useDispatch();
  const history = useHistory();
  const onClick = (e, notif) => {
    e.stopPropagation();
    if (!notif.isRead) {
      dispatch(startReadingNotification(notif._id));
    }
    history.push(`/projet/${notif.projectId}`);
    dispatch(changePage('projet'));
  };
  return /*#__PURE__*/React.createElement(Fragment, null, notifications.map((notif, index) => {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      disabled: notif.isRead,
      isPage: isPage,
      onClick: e => onClick(e, notif)
    }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(FolderContainer, null, /*#__PURE__*/React.createElement(FolderIcon, {
      size: "1x",
      icon: faFolderOpen,
      ispage: isPage.toString()
    }), !notif.isRead && /*#__PURE__*/React.createElement(RedPointIcon, {
      icon: faCircle,
      ispage: isPage.toString()
    }))), /*#__PURE__*/React.createElement(NotifContainer, {
      id: `notif-text-${index}`,
      disabled: notif.isRead
    }, /*#__PURE__*/React.createElement(NotifTextFormatted, {
      notif: notif,
      isPage: isPage
    }), /*#__PURE__*/React.createElement(NotifNameRecap, null, notif.project.name || notif.project.projectname || notif.project.dealname), /*#__PURE__*/React.createElement(NotifDate, {
      isPage: isPage
    }, dayjs(notif.createdAt).fromNow())));
  }));
};
MultiNotificationsList.propTypes = {
  notifications: PropTypes.array.isRequired,
  isPage: PropTypes.bool
};
MultiNotificationsList.defaultProps = {
  notifications: [],
  isPage: false
};
export default MultiNotificationsList;